import {ServicesCommuns} from "../../../../val-definitions-communes-lib/src/public-api";
import {ValFicheEditionBarreNavigationGroupe} from "./fiche-edition-barre-navigation/donnees-fiche-edition-barre-navigation";

//Représente les données de gestion des fiches d’édition
export class DonneesGestionFichesEdition 
{
  //Création
  constructor () 
  {
    this.vueFiche = false;
    this.donneesFichesEdition = [];
  }

  //Indique si vue fiche
  public vueFiche: boolean;

  //Données des fiches d’édition
  public donneesFichesEdition: DonneesFicheEdition[];
}

//Représente les données d’une fiche d’édition
export abstract class DonneesFicheEdition 
{
  //Création
  constructor () 
  {
    this.charge = false;
    this.active = false;
    this.edition = false;
    this.navigationCommande = [];
    this.identifiantFiche = "";
    this.identifiant = -1;
    this.libelle = "";
    this.donneesPages = [];
    this.navigationsGroupes = [];
    this.pageEnCours = "";
  }

  //Indique si les données ont été chargées
  public charge: boolean;

  //Indique si activé
  public active: boolean;

  //Indique si en édition
  public edition: boolean;

  //Commandes de navigation
  public navigationCommande: any[];

  //Identifiant de la fiche
  public identifiantFiche: string;

  //Identifiant métier
  public identifiant: number;

  //Libellé
  public libelle: string;

  //Page en cours
  public pageEnCours: string;

  //Données des pages
  protected donneesPages: DonneesPageEdition[];

  //Créé les groupes de navigation
  //  Paramètres
  //    navigationGroupes : Groupes de navigation à créer
  protected async CreerNavigationGroupes (navigationGroupes: ValFicheEditionBarreNavigationGroupe[]) : Promise<void> 
  {
    let identifiantsDicos: string[];

    identifiantsDicos = this.RetournerIdentifiantsDicos (navigationGroupes);

    await ServicesCommuns.Habilitations.ChargerHabilitations (identifiantsDicos);
    
    this.DefinirLibelle (navigationGroupes);

    this.navigationsGroupes = navigationGroupes;
  }

  //Retourne les identifiants des dicos des groupes de navigation
  //  Paramètres
  //    navigationGroupes : Groupes de navigation
  private RetournerIdentifiantsDicos (navigationGroupes: ValFicheEditionBarreNavigationGroupe[]) : string[] 
  {
    let identifiantsDicos: string[];

    identifiantsDicos = [];

    for (let groupe of navigationGroupes)
    {
      for (let item of groupe.items)
        identifiantsDicos.push (item.dico);
    }

    return identifiantsDicos;
  }

  //Définit les libellé des groupes de navigation
  //  Paramètres
  //    navigationGroupes : Groupes de navigation
  private DefinirLibelle (navigationGroupes: ValFicheEditionBarreNavigationGroupe[]) : void 
  {
    for (let groupe of navigationGroupes)
    {
      for (let item of groupe.items)
        item.libelle = ServicesCommuns.Habilitations.Habilitation (item.dico).libelle;
    }
  }

  //Groupes de navigation
  public get NavigationGroupes () : ValFicheEditionBarreNavigationGroupe[] 
  {
    return this.navigationsGroupes;
  }

  //Groupes de navigation
  private navigationsGroupes: ValFicheEditionBarreNavigationGroupe[];
  
  //Retourne les données de validation d’une fiche
  public RetournerDonneesValidation () : any 
  {
    let donneesValidation: any;

    donneesValidation = null;

    for (let page of this.donneesPages)
    {
      if (page.Modifie ())
      {
        if (!donneesValidation)
          donneesValidation = this.CreerDonneesValidation ();

        page.RecupererDonneesPage (donneesValidation);
      }	
    }

    return donneesValidation;
  }

  //Indique si modifié
  public Modifie () : boolean 
  {
    let modifie: boolean;

    modifie = false;
    
    for (let page of this.donneesPages)
    {
      if (page.Modifie ())
      {
        modifie = true;

        break;
      }	
    }

    return modifie;
  }

  //Désactive les pages
  public DesactiverPages () : void 
  {
    for (let page of this.donneesPages)
    {
      page.active = false;
    }
  }

  //Rafraichit les pages
  public async RafrichirPages () : Promise<void> 
  {
    for (let page of this.donneesPages)
    {
      await page.Rafraichir ();
    }
  }

  //Créé les données de validation
  protected abstract CreerDonneesValidation () : any;

  //Valide la fiche
  //  Paramètres
  //    donneesValidation : Données de validation de la fiche
  public abstract Valider (donneesValidation: any) : Promise<boolean>;
}

//Représente les données d’une page d’édition
export abstract class DonneesPageEdition 
{
  //Création
  //  Paramètres
  //    donneesFicheEdition : Données d’une fiche d’édition
  constructor (private donneesFicheEdition: DonneesFicheEdition) 
  {
    this.active = false;
  }

  //Active la page
  public Activer () : void 
  {
    this.donneesFicheEdition.DesactiverPages ();
    this.active = true;
  }

  //Indique si activé
  public active: boolean;

  //Indique si modifiée
  public abstract Modifie () : boolean;

  //Récupère les données de la page
  //  Paramètres
  //    donneesValidation : Données de validation
  public abstract RecupererDonneesPage (donneesValidation: any) : void;

  //Rafraichit la page
  public abstract Rafraichir () : Promise<void>;

  //Contrôle si les données ont été modifiée
  public ControlerModifie <T extends object> (a: T, b: T, ignorer: readonly (keyof T)[] = []): boolean 
  {
    let modifie: boolean;
    let cles: Set<keyof T>;

    cles = new Set([...Object.keys(a), ...Object.keys(b)]) as Set<keyof T>;

    modifie = [...cles].some (cle => !ignorer.includes(cle) && a[cle] !== b[cle]);

    return modifie;
  }  
}

//Données de gestion des fiches d’édition
export const donneesGestionFichesEdition: DonneesGestionFichesEdition = new DonneesGestionFichesEdition ();
